@if(selectedTrackingKeywordSuggestions.length === 0) {
  <div class="row">
    <div class="col-md-12">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Tracking Keywords</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>No tracking keywords have been selected yet</td>
          </tr>
          <tr>
            <td>
              <div class="row">
                <div class="col-12">
                  <app-components-shared-keyword-research-add-tracking-keyword
                    [customer]="customer"
                    [pageSuggestions]="pageSuggestions"
                    [trackingKeywordSuggestions]="trackingKeywordSuggestions"
                    [keywordConfig]="keywordConfig">
                  </app-components-shared-keyword-research-add-tracking-keyword>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
}
@else {
  <div class="row">
    <div class="col-md-12">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>
              Tracking Keywords
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let trackingKeywordSuggestion of selectedTrackingKeywordSuggestions | orderBy: keywordSort">
            <tr>
              <td>
                <app-components-shared-keyword-research-tracking-keyword
                  [keywordResearchType]="keywordResearchType"
                  [customer]="customer"
                  [pageSuggestions]="pageSuggestions"
                  [trackingKeywordSuggestion]="trackingKeywordSuggestion"
                  [trackingKeywordSuggestions]="trackingKeywordSuggestions">
                </app-components-shared-keyword-research-tracking-keyword>
              </td>
            </tr>
          </ng-container>
          <tr>
            <td>
              <div class="row">
                <div class="col-12">
                  <app-components-shared-keyword-research-add-tracking-keyword
                    [customer]="customer"
                    [pageSuggestions]="pageSuggestions"
                    [trackingKeywordSuggestions]="trackingKeywordSuggestions"
                    [keywordConfig]="keywordConfig">
                  </app-components-shared-keyword-research-add-tracking-keyword>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
}